import { z } from 'zod';
import { SUPPORTED_TAX_EXEMPTION_COUNTRIES } from 'store/shop';
import { JobStatus } from 'store/jobs';
import { adminClientsFiltersSchema } from './admin-clients.schemas';

export const clientFeatures = [
  'benefits',
  'news',
  'recognition',
  'marketplace',
  'marketplaceV2',
  'claimReimbursement',
  'companyItems',
  'discounts',
  'manualExpenses',
  'comments',
  'employeePayment',
  'conversationalAgent',
  'ai',
  'trustbox',
  'trainings',
  'forms',
  'colleagues',
  'orgStructure',
  'advancedPermissions',
  'advancedPermissionsView',
  ...SUPPORTED_TAX_EXEMPTION_COUNTRIES.map(
    (country) => `taxExemption${country}` as const,
  ),
] as const;
export type ClientFeature = (typeof clientFeatures)[number];

export const depositManagementMethods = ['company', 'clientAccount'] as const;
export type DepositManagementMethod = (typeof depositManagementMethods)[number];

export type AdminClientsFilters = z.infer<typeof adminClientsFiltersSchema>;

export interface UnlinkAppUsersProgress {
  processed: number;
  total: number;
  failed: number;
}

export interface UnlinkAppUsersStatus {
  status: JobStatus | null;
  progress: UnlinkAppUsersProgress | null;
  error?: string;
  ranAt?: string;
}
